export default __webpack_public_path__ + "static/media/js.70fde9fe.png";